import React from 'react';
import styled from '@emotion/styled';
import { Position } from 'geojson';
import { Popup } from '@robinpowered/atlas-web';
import { Colors } from '@robinpowered/design-system';
import './NeighborhoodPopup.css';
import { css } from '@emotion/react';

type NeighborhoodPopupProps = {
  neighborhood: {
    id: string;
    name: string;
    colorDefinition: {
      base: string;
      label: {
        text: string;
        background: string;
      };
    };
  };
  centroid?: Position;
  showColor?: boolean;
};

export const NeighborhoodPopup = ({
  neighborhood,
  centroid,
  showColor = true,
}: NeighborhoodPopupProps): JSX.Element | null => {
  if (!centroid) {
    return null;
  }

  const neighborhoodColor = neighborhood.colorDefinition.base;
  const neighborhoodLabelBackground =
    neighborhood.colorDefinition.label.background;

  return (
    <Popup
      key={neighborhood.id}
      lngLat={centroid}
      className="neighborhood-popup"
    >
      <NeighborhoodLabelContainer
        data-label="neighborhood"
        showColor={showColor}
        color={neighborhoodColor}
        backgroundColor={neighborhoodLabelBackground}
      >
        {neighborhood.name}
      </NeighborhoodLabelContainer>
    </Popup>
  );
};

const labelStyles = `
  font-size: 16px;
  padding: 6px 12px;
  background-color: ${Colors.White0};
  border-radius: 30px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15), 0px 2px 12px rgba(0, 0, 0, 0.06);
  text-align: center;
`;

export const NeighborhoodLabelContainer = styled.div<{
  showColor: boolean;
  color: string;
  backgroundColor: string;
}>`
  ${labelStyles}
  ${({ showColor, color, backgroundColor }) =>
    showColor &&
    css`
      color: ${color};
      border-color: ${color};
      border: 2px solid;
      background-color: ${backgroundColor};
    `}
  user-select: none;
  cursor: pointer;
  word-wrap: break-word;
`;
